import styled from 'styled-components'
import { tokens } from '../../../assets/tokens'

export const TagList = styled.div`
  display: flex;
  flex-direction: column;

  .tag-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 4px 0;
    border-bottom: 1px solid ${tokens.color.border.subtle};

    :last-child {
      border-bottom: none;
    }
  }
`
